import React from 'react';
import { useTheme } from '../theme/ThemeContext';

/** Skeleton placeholders for heavy dashboard blocks. */
export default function Skeleton({
  rows = 4,
  minHeight = 220,
  variant = 'cards', // cards | table | lines
}) {
  useTheme();
  const pulse = {
    background: 'linear-gradient(90deg, color-mix(in srgb, var(--border) 55%, transparent) 0%, var(--bg-input) 45%, color-mix(in srgb, var(--border) 55%, transparent) 100%)',
    backgroundSize: '200% 100%',
    animation: 'skeleton-shimmer 1.35s ease-in-out infinite',
    borderRadius: 10,
  };

  if (variant === 'table') {
    return (
      <div
        className="skeleton-block"
        style={{ minHeight, padding: 16 }}
        role="status"
        aria-busy="true"
        aria-label="Загрузка"
      >
        <div style={{ ...pulse, height: 18, width: '40%', marginBottom: 16 }} />
        {Array.from({ length: rows }).map((_, i) => (
          <div key={i} style={{ ...pulse, height: 36, marginBottom: 10, opacity: 1 - i * 0.08 }} />
        ))}
      </div>
    );
  }

  if (variant === 'lines') {
    return (
      <div className="skeleton-block" style={{ minHeight, padding: 16 }} role="status" aria-busy="true">
        {Array.from({ length: rows }).map((_, i) => (
          <div
            key={i}
            style={{
              ...pulse,
              height: 14,
              width: `${70 - i * 8}%`,
              marginBottom: 12,
            }}
          />
        ))}
      </div>
    );
  }

  return (
    <div
      className="skeleton-block"
      style={{
        minHeight,
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))',
        gap: 12,
        padding: 8,
      }}
      role="status"
      aria-busy="true"
      aria-label="Загрузка"
    >
      {Array.from({ length: Math.max(rows, 3) }).map((_, i) => (
        <div key={i} style={{ ...pulse, height: 88 }} />
      ))}
    </div>
  );
}
